function initCornerPopups() {
    const popups = document.querySelectorAll('.corner-popup');
    popups.forEach(popup => {
        // If already open (e.g. design mode), skip logic
        if (popup.hasAttribute('open')) return;

        const delay = Number(popup.dataset.delay) || 5;
        const popupId = popup.id;
        const storageKey = `corner-popup-closed-${popupId}`;

        // Check functionality: if already closed by user, do not show
        if (localStorage.getItem(storageKey)) return;

        // Show after delay
        setTimeout(() => {
            // Use show() vs showModal() - corner popup is usually non-blocking
            // However, it's a dialog element.
            // Using open attribute to trigger CSS animation
            popup.show(); // This adds open attribute
            // Or manually: popup.setAttribute('open', '');
        }, delay * 1000);

        // Close Handling
        const closeBtn = popup.querySelector('.corner-popup__close');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                closePopup(popup, storageKey);
            });
        }

        // Close Handling
        const skipBtn = popup.querySelector('.corner-popup-skip-btn"');
        if (skipBtn) {
            skipBtn.addEventListener('click', () => {
                closePopup(popup, storageKey);
            });
        }

        // Any link click should count as interaction
        const links = popup.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('click', () => {
                setPopupClosed(storageKey);
            });
        });
    });
}

function closePopup(popup, key) {
    popup.close(); // Removes open attribute
    setPopupClosed(key);
}

function setPopupClosed(key) {
    localStorage.setItem(key, 'true');
}

document.addEventListener('DOMContentLoaded', initCornerPopups);
// Handle Shopify Design Mode events if needed to re-init
document.addEventListener('shopify:section:load', initCornerPopups);
